export const disableFeature = (
  featuresArray: Array<Object>,
  featureName: string
) => {
  const enabled = featuresArray.includes(featureName)
  return !enabled
}
